import { Box } from "@mui/system";
import GraphSkeletonForTrendsMob from "../../../helpers/components/GraphSkeletonForTrendsMob";
import { useSelector } from "react-redux";
import CPAIncomeChartWrap from "./CPAContent/CPAIncome/CPAIncomeChartWrap";
import CPAPlayerValueChartWrap from "./CPAContent/CPAPlayerValue/CPAPlayerValueChartWrap";
import AvgDealCPAIncomeChartWrap from "./CPAContent/AvgDealCPAIncome/AvgDealCPAIncomeChartWrap";

const CPA = () => {
  const { loadingTrendsMobData } = useSelector((state: any) => state.trends);
  return (
    <>
      <Box sx={{ px: 2 }}>
        {loadingTrendsMobData ? (
          Array.from({ length: 2 }).map((_, index) => (
            <GraphSkeletonForTrendsMob key={index} />
          ))
        ) : (
          <>
            <CPAIncomeChartWrap />
            <CPAPlayerValueChartWrap />
            <AvgDealCPAIncomeChartWrap />
          </>
        )}
      </Box>
    </>
  );
};

export default CPA;
